/*
 *
 * PblManagementActionsModal
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 10-Jul-2025
 */

import PblManagementActionsModal from './PblManagementActionsModalContainer'

export default PblManagementActionsModal
